var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrivate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#3E3E41",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M15.4 8A7.4 7.4 0 1 1 .6 8a7.4 7.4 0 0 1 14.8 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3E3E41",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.2,
    d: "M10.926 9.026c-.8.8-1.948 1.048-2.961.73L6.13 11.582a.746.746 0 0 1-.58.191l-.85-.113c-.284-.036-.539-.305-.582-.581l-.113-.85a.793.793 0 0 1 .191-.581l1.828-1.828a2.953 2.953 0 0 1 .73-2.96 2.959 2.959 0 0 1 4.172 0c1.147 1.14 1.147 3.01 0 4.165ZM6.796 10.918l-.602-.61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3E3E41",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M8.882 6.964h.006"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivate);
export default __webpack_public_path__ + "static/media/private.dff50a1a1ae50add5ed9c3f141257e13.svg";
export { ForwardRef as ReactComponent };